import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide011CouplesCoachingMethodology() {
  return <KbGuidePage slug="guide-011-couples-coaching-methodology" />;
}

(Guide011CouplesCoachingMethodology as unknown as { path: string }).path = "/guides/couples-coaching-methodology";
